export default __webpack_public_path__ + "static/477f324e-236a-4290-81be-3dc6cd89aee5-76b6830068ea3df718cac8e031d592cd.woff2";